(function () {
    var STORAGE_KEY = 'cc_consent_v2';
    var CONSENT_TTL = 365 * 24 * 60 * 60 * 1000;
    var lang = (document.documentElement.lang || 'en').slice(0, 2);

    var strings = {
      en: {
        title: 'Cookie preferences',
        desc: 'We use cookies to analyze our traffic and improve your experience. No non-essential cookies are set without your explicit consent.',
        privacy: 'Privacy policy',
        customize: 'Customize choices',
        hideDetails: 'Hide details',
        acceptAll: 'Accept all',
        declineAll: 'Decline all',
        save: 'Save my choices',
        essential: { label: 'Essential', desc: 'Required for the site to function (cart, checkout, security). Always active.' },
        analytics: { label: 'Analytics', desc: 'Help us understand how visitors use the site (Google Analytics).' },
        marketing: { label: 'Marketing', desc: 'Used to show relevant ads and measure campaigns.' },
        preferences: { label: 'Preferences', desc: 'Remember your settings like language or region.' }
      },
      fr: {
        title: 'Pr\u00e9f\u00e9rences de t\u00e9moins',
        desc: 'Nous utilisons des t\u00e9moins pour analyser notre trafic et am\u00e9liorer votre exp\u00e9rience. Aucun t\u00e9moin non essentiel n\u2019est activ\u00e9 sans votre consentement explicite.',
        privacy: 'Politique de confidentialit\u00e9',
        customize: 'Personnaliser les choix',
        hideDetails: 'Masquer les d\u00e9tails',
        acceptAll: 'Tout accepter',
        declineAll: 'Tout refuser',
        save: 'Enregistrer mes choix',
        essential: { label: 'Essentiels', desc: 'N\u00e9cessaires au fonctionnement du site (panier, paiement, s\u00e9curit\u00e9). Toujours actifs.' },
        analytics: { label: 'Analytiques', desc: 'Nous aident \u00e0 comprendre comment les visiteurs utilisent le site (Google Analytics).' },
        marketing: { label: 'Marketing', desc: 'Utilis\u00e9s pour des publicit\u00e9s pertinentes et mesurer les campagnes.' },
        preferences: { label: 'Pr\u00e9f\u00e9rences', desc: 'Retiennent vos param\u00e8tres comme la langue ou la r\u00e9gion.' }
      }
    };

    var t = strings[lang] || strings.en;

    function getConsent() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (Date.now() - data.ts > CONSENT_TTL) {
          localStorage.removeItem(STORAGE_KEY);
          return null;
        }
        return data;
      } catch (e) {
        return null;
      }
    }

    function setConsent(analytics, marketing, preferences) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          analytics: analytics,
          marketing: marketing,
          preferences: preferences,
          ts: Date.now()
        }));
      } catch (e) {}
    }

    function applyConsent(consent) {
      gtag('consent', 'update', {
        'analytics_storage': consent.analytics ? 'granted' : 'denied',
        'ad_storage': consent.marketing ? 'granted' : 'denied',
        'ad_user_data': consent.marketing ? 'granted' : 'denied',
        'ad_personalization': consent.marketing ? 'granted' : 'denied',
        'functionality_storage': consent.preferences ? 'granted' : 'denied',
        'personalization_storage': consent.preferences ? 'granted' : 'denied'
      });

      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function(error) {
            if (error || !window.Shopify.customerPrivacy) return;
            window.Shopify.customerPrivacy.setTrackingConsent({
              analytics: consent.analytics,
              marketing: consent.marketing,
              preferences: consent.preferences,
              sale_of_data: false
            }, function() {});
          }
        );
      }
    }

    function populateText() {
      document.getElementById('cc-title').textContent = t.title;
      document.getElementById('cc-desc').textContent = t.desc;
      document.getElementById('cc-privacy-link').textContent = t.privacy;
      document.getElementById('cc-toggle-details').textContent = t.customize;
      document.getElementById('cc-accept').textContent = t.acceptAll;
      document.getElementById('cc-decline').textContent = t.declineAll;
      document.getElementById('cc-save').textContent = t.save;
      document.getElementById('cc-cat-essential-label').textContent = t.essential.label;
      document.getElementById('cc-cat-essential-desc').textContent = t.essential.desc;
      document.getElementById('cc-cat-analytics-label').textContent = t.analytics.label;
      document.getElementById('cc-cat-analytics-desc').textContent = t.analytics.desc;
      document.getElementById('cc-cat-marketing-label').textContent = t.marketing.label;
      document.getElementById('cc-cat-marketing-desc').textContent = t.marketing.desc;
      document.getElementById('cc-cat-preferences-label').textContent = t.preferences.label;
      document.getElementById('cc-cat-preferences-desc').textContent = t.preferences.desc;
    }

    /* Top layer (popover="manual") : le popup Shopify Forms (app) est au meme z-index
       plafond et plus loin dans le DOM -> il avalait le tap sur « Decline all » a 375px.
       Aucun z-index ne passe devant ; le top layer, si. Repli : affichage classique. */
    function ccReveal(banner) {
      banner.style.display = '';
      if (typeof banner.showPopover === 'function') {
        if (!banner.hasAttribute('popover')) banner.setAttribute('popover', 'manual');
        try { if (!banner.matches(':popover-open')) banner.showPopover(); } catch (e) {}
      }
    }
    function ccHide(banner) {
      try { if (banner.matches(':popover-open')) banner.hidePopover(); } catch (e) {}
      banner.style.display = 'none';
    }

    function ccApplyBodyPadding() {
      var banner = document.getElementById('cc-banner');
      if (!banner || banner.style.display === 'none') return;
      document.body.style.paddingBottom = banner.offsetHeight + 'px';
      /* Meme hauteur pour les elements fixes en bas (mini-panier, barre panier) */
      document.documentElement.style.setProperty('--cc-h', banner.offsetHeight + 'px');
    }
    function ccRemoveBodyPadding() {
      document.body.style.paddingBottom = '';
      document.documentElement.style.removeProperty('--cc-h');
      window.removeEventListener('resize', ccApplyBodyPadding);
    }

    function showBanner() {
      var banner = document.getElementById('cc-banner');
      var details = document.getElementById('cc-details');
      var toggleBtn = document.getElementById('cc-toggle-details');
      var saveBtn = document.getElementById('cc-save');
      var analyticsBox = document.getElementById('cc-analytics');
      var marketingBox = document.getElementById('cc-marketing');
      var prefsBox = document.getElementById('cc-preferences');

      populateText();
      ccReveal(banner);
      ccApplyBodyPadding();
      window.addEventListener('resize', ccApplyBodyPadding);

      toggleBtn.addEventListener('click', function () {
        var expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          details.hidden = true;
          toggleBtn.setAttribute('aria-expanded', 'false');
          toggleBtn.textContent = t.customize;
          saveBtn.style.display = 'none';
        } else {
          details.hidden = false;
          toggleBtn.setAttribute('aria-expanded', 'true');
          toggleBtn.textContent = t.hideDetails;
          saveBtn.style.display = '';
        }
        requestAnimationFrame(ccApplyBodyPadding);
      });

      document.getElementById('cc-accept').addEventListener('click', function () {
        setConsent(true, true, true);
        applyConsent({ analytics: true, marketing: true, preferences: true });
        ccHide(banner);
        ccRemoveBodyPadding();
      });

      document.getElementById('cc-decline').addEventListener('click', function () {
        setConsent(false, false, false);
        applyConsent({ analytics: false, marketing: false, preferences: false });
        ccHide(banner);
        ccRemoveBodyPadding();
      });

      saveBtn.addEventListener('click', function () {
        var c = {
          analytics: analyticsBox.checked,
          marketing: marketingBox.checked,
          preferences: prefsBox.checked
        };
        setConsent(c.analytics, c.marketing, c.preferences);
        applyConsent(c);
        ccHide(banner);
        ccRemoveBodyPadding();
      });
    }

    window.ccShowBanner = function () {
      var banner = document.getElementById('cc-banner');
      var details = document.getElementById('cc-details');
      var toggleBtn = document.getElementById('cc-toggle-details');
      var saveBtn = document.getElementById('cc-save');

      var stored = getConsent();
      if (stored) {
        document.getElementById('cc-analytics').checked = stored.analytics;
        document.getElementById('cc-marketing').checked = stored.marketing;
        document.getElementById('cc-preferences').checked = stored.preferences;
      }

      populateText();
      details.hidden = true;
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.textContent = t.customize;
      saveBtn.style.display = 'none';
      ccReveal(banner);
      ccApplyBodyPadding();
      window.addEventListener('resize', ccApplyBodyPadding);
    };

    var stored = getConsent();
    if (stored) {
      applyConsent(stored);
    } else {
      showBanner();
    }
  })();
